// extracted by mini-css-extract-plugin
module.exports = {"container":"Styles_container__AL0zM","item":"Styles_item__tS6_p","number":"Styles_number__XZMGW","dark":"Styles_dark__W8Kws","caption":"Styles_caption__VtuOU"};